<tt-page>
    <tt-webpagemenu [customWidgets]="customWidgets" [ttName]="webpageName"></tt-webpagemenu>
</tt-page>
